export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_mktech.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a MKTECH",
    text: [
      "Automações pensadas em gerenciar corretamente o risco, buscando retornos consistentes a longo prazo. \n Pouco risco, muita constância. ",
    ],
    testimonial: {
      text: "Automações feitas por quem vive de mercado, estratégias reais, com base de conhecimento de 2 décadas de mercado.",
      author: {
        name: "Vinicius Miguel – Milho King ",
      },
    },
  },
  stats: {
    title: "Alguns números da MKTECH",
    subtitle: "Mais de 20 anos de experiência real do mercado financeiro",
    data: [
      {
        value: "+1000",
        description: "Métodos validados por mais de 1.000 alunos",
      },
      {
        value: "+10",
        description: "Anos em atividade",
      },
      {
        value: "+1M",
        description: "De ordens executadas",
      },
    ],
  },
  features: {
    title: "Robôs feitos por traders reais ",
    subtitle:
      "Antes de automatizar é preciso conhecer, desenvolver e testar, os robôs da MKTECH utilizam estratégias validas ao longo da história",
    data: [
      {
        title: "7 dias para testar ",
        description: "Teste nossas estratégias e veja você mesmo. ",
      },
      {
        title: "Um trader profissional a um clique de distância ",
        description: "Já imaginou com um clique, ter um trader profissional atuando por você?",
      },
      {
        title: "Emocional de Ferro",
        description:
          "O robô apenas executa, não pensa “se”, não fica preocupado com o trade anterior, não deixa de executar a próxima a entrada por medo.",
      },
    ],
  },
  cta: {
    title: "O futuro é agora.",
    subtitle: "Ative agora a extensão MKTECH ",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "MKTECH ",
    col1: [
      "Criada a partir da experiência de um trader com mais de 20 anos de mercado, a empresa une prática operacional, leitura de cenário e tecnologia para desenvolver automações voltadas a traders. ",
      "Antes de ser automatizado, o método foi construído e validado na operação manual, com foco em disciplina, gestão de risco e consistência. Hoje, essa experiência é traduzida em ferramentas que ajudam o trader a enxergar oportunidades, organizar sua tomada de decisão e operar com mais método. ",
    ],
    col2: ["Mais do que robôs, desenvolvemos soluções pensadas por quem vive o mercado na prática."],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da MKTech",
  },
  strategies: {
    title: "Estratégias MKTECH",
    heading: "Robôs de alta perfomance, na palma da sua mão.",
    subtitle: "Estratégias pensadas da entrada até a saída, comece agora mesmo e dê um “play” na sua virada de chave. ",
  },
};
